import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-submit"
// data-action="keydown.enter->form-submit#submit:prevent"
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
